import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query omieMunicipalServices($integrationId: Int, $page: Int) {
    omieMunicipalServices(integrationId: $integrationId, page: $page, limit: 30) {
      cCodServMun
      cDescricao
      nIdCodServMun
    }
  }
`

export const useServiceOrCNAESelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieMunicipalServices']))
      .then(data => {
        const result = data.map((item, index) => {
          return { id: index, name: `${item?.nIdCodServMun} ${item?.cDescricao}`, cCodServMun: item?.cCodServMun }
        })

        return result
      })
  }
}

const ServiceOrCNAESelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useServiceOrCNAESelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default ServiceOrCNAESelect
